import { render, staticRenderFns } from "./releaseDialog.vue?vue&type=template&id=dc1cb128"
import script from "./releaseDialog.vue?vue&type=script&lang=js"
export * from "./releaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports